import React from 'react';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';
import ThemedText from '../theme/ThemedText';
import DropdownFilter from './DropdownFilter';

const OPTIONS = {
  engagement: {
    name: 'Most voted',
    value: 'engagement',
  },
  'engagement-likes': {
    name: 'Most supported',
    value: 'engagement-likes',
  },
  'engagement-dislikes': {
    name: 'Most opposed',
    value: 'engagement-dislikes',
  },
};

const FiterDetails = ({ isActive, item, onClick }) => {
  return (
    <Flexbox
      gap='0.5rem'
      fw
      justifyContent='flex-start'
      className={isActive ? 'chaindropdown_wrapper__active' : 'chaindropdown_wrapper__chainDetails'}
      onClick={() => onClick(item?.value)}
    >
      <ThemedText.P>{item?.name}</ThemedText.P>
    </Flexbox>
  );
};

const ReviewSort = ({ filter, onChange }) => {
  function onClick(value) {
    if (filter === value) {
      return onChange(null);
    }
    onChange(value);
  }
  return (
    <DropdownFilter heading={filter ? OPTIONS[filter]?.name : 'Most Recent'} contentClassName={'chaindropdown_wrapper'} selected={filter} onRemove={() => onClick(filter)}>
      <FlexboxColumn gap='1rem' alignItems={'flex-start'} fw>
        {Object.values(OPTIONS).map((item, idx) => (
          <FiterDetails key={`reviewsort-${idx}`} item={item} isActive={filter === item?.value} onClick={onClick} />
        ))}
      </FlexboxColumn>
      {/* </FlexboxColumn> */}
    </DropdownFilter>
  );
};

export default ReviewSort;
